export const SPRAY_EVENT_MULTIPLE_OPERATORS_TAB_SET_ACTIVE_INDEX =
    'SPRAY_EVENT_MULTIPLE_OPERATORS_TAB_SET_ACTIVE_INDEX';
